//@flow
import * as React from 'react';
import Input from 'common/components/core/input/Input';
import { ButtonWithPopoverList } from 'common/components/core/button';
import { translate } from 'react-i18next';

const InputWithButtonPopoverList = ({
    clearableInput = true,
    t,
    onClearInput,
    listOptions,
    listOptionRenderer,
    selectedValues,
    theme,
    listRowHeight,
    listWidth,
    listHeight,
    listRef,
    placeholder,
    disabled,
    preferPlace,
    ...others
}) => {
    return (
        <Input
            {...others}
            disabled={disabled}
            theme={theme}
            onClearInput={onClearInput}
            clearableInput={clearableInput}
            placeholder={placeholder || t('search')}
            rightIcon={
                <ButtonWithPopoverList
                    disabled={disabled}
                    listOptions={listOptions}
                    listOptionRenderer={listOptionRenderer}
                    theme={theme}
                    selectedValues={selectedValues}
                    listRowHeight={listRowHeight}
                    listWidth={listWidth}
                    listHeight={listHeight}
                    listRef={listRef}
                    preferPlace={preferPlace}
                />
            }
        />
    );
};

export default translate()(InputWithButtonPopoverList);
